// extracted by mini-css-extract-plugin
export default {"btn":"table-info_btn__Z-3f7","error":"table-info_error__paB5S","errorText":"table-info_errorText__3UM1s"};